module.exports = __webpack_public_path__ + "img/east-map.df56f4ee.png";